export class AccountUser {
    id!: string;
    userId!: string;
    userName?: string;
    userEmail?: string;
    accountId!: number;
    active!: boolean;
    clockInUrl!: string;
}